import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPciSecurityStandards = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_4141_50086)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M24 14.083L5.41562 19.9152L0 5.17271L19.5101 4.08496L24 14.083Z",
				fill: "#02797E"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M9.95221 11.1207C9.95221 11.491 9.85964 11.815 9.69763 12.1159C9.53563 12.3936 9.30419 12.6482 9.00332 12.8333C8.70246 13.0185 8.33216 13.1573 7.91557 13.2499C7.49898 13.3425 7.03611 13.3888 6.5038 13.3888H6.13351V15.2866H3.72656V8.96833H6.55009C7.6147 8.96833 8.44787 9.15348 9.04961 9.50064C9.65135 9.84779 9.95221 10.4032 9.95221 11.1207ZM7.63785 11.1438C7.63785 10.5884 7.22126 10.3107 6.41123 10.3107H6.11036V12.0002H6.38809C6.78153 12.0002 7.10554 11.9307 7.31383 11.7919C7.52213 11.6761 7.63785 11.4447 7.63785 11.1438ZM15.9233 15.2866C15.553 15.356 15.1364 15.4023 14.6504 15.4023C13.9792 15.4023 13.3775 15.3328 12.8683 15.1708C12.336 15.0088 11.8963 14.8005 11.526 14.5228C11.1557 14.2451 10.878 13.8979 10.6928 13.5045C10.5077 13.0879 10.4151 12.6482 10.4151 12.1622C10.4151 11.6761 10.5077 11.2364 10.716 10.8198C10.9273 10.4179 11.2188 10.0635 11.5723 9.77836C11.9426 9.50064 12.3823 9.2692 12.8915 9.1072C13.4006 8.94519 13.9561 8.87576 14.5578 8.87576C15.0207 8.87576 15.4604 8.8989 15.8539 8.96833C16.2473 9.06091 16.2473 9.06091 16.5482 9.17663V10.8661C16.3167 10.7273 16.039 10.6115 15.7381 10.5421C15.4373 10.4495 15.1133 10.4032 14.7892 10.4032C14.2338 10.4032 13.7941 10.5652 13.4469 10.843C13.0998 11.1438 12.9378 11.5604 12.9378 12.139C12.9378 12.4167 12.984 12.6713 13.0998 12.9028C13.2155 13.1111 13.3543 13.2962 13.5395 13.4351C13.7246 13.5739 13.9329 13.6896 14.1875 13.7591C14.4421 13.8285 14.6967 13.8748 14.9744 13.8748C15.2521 13.8748 15.553 13.8517 15.8307 13.7822C16.1084 13.7128 16.4093 13.6434 16.7102 13.5045V15.1014L15.9233 15.2866ZM17.7053 8.96833H20.1354V15.3097H17.7053V8.96833ZM20.39 6.97798C20.39 7.39456 20.2512 7.74172 19.9734 7.97316C19.6957 8.20459 19.3486 8.34345 18.932 8.34345C18.5154 8.34345 18.1682 8.22774 17.8905 7.97316C17.6128 7.74172 17.4739 7.39456 17.4739 6.97798C17.4739 6.53825 17.6128 6.21424 17.8905 5.95965C18.1682 5.70507 18.5154 5.58936 18.932 5.58936C19.3486 5.58936 19.6957 5.70507 19.9734 5.95965C20.2512 6.19109 20.39 6.53825 20.39 6.97798Z",
				fill: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4141_50086",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgPciSecurityStandards);
export { ForwardRef as ReactComponent };
